import styled from 'styled-components';
import CheckSvg from 'library/icons/check.svg';
import { withColor } from 'util/hoc';

const StyledContainer = styled.div`
  width: 100%;
  cursor: ${(props) => (props.disabled ? 'unset' : 'pointer')};
  display: flex;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckBox = styled.div`
  height: 25px;
  width: 100%;
  display: flex;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
`;

const StyledLabel = styled.span`
  font-size: 13px;
  margin: auto 0.5em;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledBox = withColor(styled.div`
  border: solid 2px
    ${(props) =>
      props.checked ? props.colors.secondary : props.theme.colors.grey400};
  border-radius: 4px;
  ${(props) => props.checked && `background-color: ${props.colors.secondary};`}
  text-align: center;
  width: 25px;
  height: 20px;
  margin: auto 0.5em;
  display: flex;
  span {
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-weight: bold;
  }
`);

const StyledCheckSvg = withColor(styled(CheckSvg)`
  g {
    g {
      fill: white;
    }
  }
`);

export {
  StyledContainer,
  HiddenCheckbox,
  StyledCheckBox,
  StyledLabel,
  StyledBox,
  StyledCheckSvg,
};
